module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/Two-43f2bfbd4854c2d779530dca660b1708.svg";